const getDisplayName = (file) => {
  if (file.originalName || file.name) {
    return file.originalName || file.name;
  }

  const keyParts = (file.key || "").split("/").filter(Boolean);
  return keyParts[keyParts.length - 1] || "";
};

const compareNames = (fileA, fileB) =>
  getDisplayName(fileA).localeCompare(getDisplayName(fileB), "fr", {
    numeric: true,
    sensitivity: "base"
  });

export const getDocumentFileComparator = (orderType) => {
  const direction = orderType.endsWith("Down") ? -1 : 1;

  if (orderType.startsWith("dateModified")) {
    return (fileA, fileB) => {
      const dateDifference =
        (Number(fileA.modified) || 0) - (Number(fileB.modified) || 0);

      return direction * dateDifference || compareNames(fileA, fileB);
    };
  }

  return (fileA, fileB) => direction * compareNames(fileA, fileB);
};
